export const APP_NAME = 'UserProfile'
export const TOKEN = `token-${APP_NAME}`
export const MANAGE_OWN_USERS = 'UserProfile_ManageOwnUsers'
export const MANAGE_OTHER_USERS = 'UserProfile_ManageOtherUsers'
export const MANAGE_EMAIL_PREFERENCES = 'UserProfile_EmailPreferences'
export const PHARMA = 'Pharma'
export const BIOLOGICS = 'Biologics'
